import {
	HttpEvent,
	HttpHandler,
	HttpInterceptor,
	HttpRequest,
} from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable, finalize } from "rxjs";
import * as uuid from "uuid";
import { LoaderService } from "../providers/loader.service";

@Injectable()
export class LoaderInterceptor implements HttpInterceptor {
	constructor(private readonly _loaderService: LoaderService) {}

	intercept(
		request: HttpRequest<any>,
		next: HttpHandler,
	): Observable<HttpEvent<any>> {
		// Register request
		const requestId = uuid.v4();
		this._loaderService.register(requestId);

		return next.handle(request).pipe(
			finalize(() => {
				this._loaderService.unregister(requestId);
			}),
		);
	}
}
